const Menu = [
  { header: "menu.apps" },
  {
    title: "menu.dashboard",
    group: "apps",
    icon: "dashboard",
    name: "Dashboard"
  },
  {
    title: "menu.orders",
    group: "apps",
    icon: "receipt",
    name: "orders"
  },
  {
    title: "menu.api.title",
    group: "api",
    component: "api",
    icon: "widgets",
    items: [
      {
        name: "apiApps",
        title: "menu.api.apiApps",
        component: "api/apps"
      },
      {
        name: "requests",
        title: "menu.api.requests",
        component: "api/requests"
      },
      {
        name: "callbacks",
        title: "menu.api.callbacks",
        component: "api/callbacks"
      }
    ]
  },
  { header: "menu.profile.title" },
  {
    title: "menu.profile.updateProfile",
    group: "profile",
    icon: "person",
    name: "profile"
  },
  {
    title: "menu.profile.updatePassword",
    group: "profile",
    icon: "security",
    name: "changePassword"
  },
  { divider: true },

  { header: "menu.payoutSettings.title" },
  {
    title: "menu.payoutSettings.withdrawals",
    group: "payout",
    icon: "local_atm",
    name: "withdrawals"
  },
  {
    title: "menu.payoutSettings.wallets.title",
    group: "wallets",
    component: "wallets",
    icon: "account_balance_wallet",
    items: [
      {
        title: "menu.payoutSettings.wallets.bitcoin",
        group: "payout",
        name: "bitcoin",
        component: "wallets/bitcoin"
      },
      {
        title: "menu.payoutSettings.wallets.cardano",
        group: "payout",
        name: "cardano",
        component: "wallets/cardano"
      },
      {
        title: "menu.payoutSettings.wallets.stellar",
        group: "payout",
        name: "stellar",
        component: "wallets/stellar"
      },
      {
        title: "menu.payoutSettings.wallets.ripple",
        group: "payout",
        name: "ripple",
        component: "wallets/ripple"
      },
      {
        title: "menu.payoutSettings.wallets.ethereum",
        group: "payout",
        name: "ethereum",
        component: "wallets/ethereum"
      }
    ]
  },
  { divider: true },
  { header: "menu.directPayment.title" },
  {
    title: "menu.directPayment.wallet",
    group: "directPayment",
    component: "directPayment",
    icon: "account_balance",
    items: [
      {
        title: "menu.payoutSettings.wallets.bitcoin",
        group: "payment",
        name: "bitcoin",
        component: "directPayment/bitcoin"
      }
    ]
  }
];
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;
